import clsx from 'clsx';

type BetaTagProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const sizeClasses = {
  small: 'px-2 py-1 text-xs',
  medium: 'px-3 py-2 text-sm',
  large: 'px-4 py-3 text-base',
};

export const BetaTag = ({ size = 'small', className }: BetaTagProps) => {
  const sizeClass = sizeClasses[size];

  return (
    <div
      className={clsx(
        'w-fit h-fit',
        'rounded-lg',
        'bg-primary-200 text-neutral-700',
        sizeClass,
        className,
      )}
    >
      BETA
    </div>
  );
};
